const DEFAULT_ERROR_MONITOR_OPERATORS = ['info@redlineautomotiveservice.ca'];

const errorMonitorOperators = String(
  process.env.REACT_APP_ERROR_MONITOR_ALLOWED_EMAILS
  || DEFAULT_ERROR_MONITOR_OPERATORS.join(',')
)
  .split(',')
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

export const canAccessErrorMonitor = (user) => {
  const email = String(user?.email || '').trim().toLowerCase();
  return ['owner', 'admin'].includes(user?.role) && errorMonitorOperators.includes(email);
};
